<div>
	<a href="{{url}}" target="_blank"></a>
	<p><small>{{originalFilename}}</small></p>
</div>
